'use client';

import { isEmpty } from 'es-toolkit/compat';

import { Badge } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { center, grid, stack } from '@flipster/styled-system/patterns';

import { ImageOrLottie } from '@web/app/[locale]/campaign/[slug]/_sections/spooky-treats-festival/image-or-lottie';
import { LuckyDrawItemFragment } from '@web/app/[locale]/campaign/[slug]/query.generated';
import { LuckyDrawPrize } from '@web/graphql/types.generated';

import { useSpookyTreatsFestivalLuckyDraw } from '../useLuckyDraw';

interface Props {
  luckyDrawData: LuckyDrawItemFragment[];
}

export const Rewards = ({ luckyDrawData }: Props) => {
  const prizes = luckyDrawData.flatMap((data) => data.prizesCollection?.items ?? []) as LuckyDrawPrize[];

  const { rewards } = useSpookyTreatsFestivalLuckyDraw();

  if (isEmpty(rewards) || isEmpty(prizes)) return null;

  return (
    <div
      className={stack({
        gap: 10,
        p: 20,
        rounded: 16,
        bg: 'background.default.level-1',
        mt: { base: 40, tablet: 32 },
        tabletDown: { mx: -16 },
      })}
    >
      <p
        className={css({
          textStyle: 'Title/XS',
          color: 'content.default.level-4',
          textAlign: 'left',
        })}
      >
        Your rewards:
      </p>
      <ul
        className={grid({
          gridTemplateColumns: { base: 'repeat(2, 1fr)', tablet: 'repeat(auto-fill, minmax(156px, max-content))' },
          gap: 8,
        })}
      >
        {rewards.map((reward) => {
          const prize = prizes.find((prize) => prize.id === reward.id);
          if (!prize) return null;
          return (
            <li key={reward.id} className={center({ bg: 'background.default.level-2', px: 16, py: 8, rounded: 8 })}>
              <div className={center({ w: 85, h: 85 })}>
                <ImageOrLottie url={prize.image?.url ?? ''} alt={prize.name ?? ''} css={{ w: '100%' }} />
              </div>
              <Badge type='tint' color='promotion'>{`x${reward.count}`}</Badge>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
